// extracted by mini-css-extract-plugin
export default {"wrap":"Ns-z","logoContainer":"Os-z","brandImg":"Ps-z","logoImg":"Qs-z","logoButton":"Rs-z"};